import React from 'react'
import { connect } from 'react-redux'
import { Route } from 'react-router'
import PropTypes from 'prop-types' 
import * as inboundProgramActions from '../actions/inboundProgram'

class EagleRoute extends React.Component {
	constructor(props) {
		super(props) 
		this.state = {
			fetchNumbers: props.fetchNumbers
		}
	}
 

	componentDidMount() {
		this.state.fetchNumbers()
	}

	render() {
		const { roles, component: Component, ...rest } = this.props 
		
			return (	<Route
					{...rest}
					render={props =>
						<Component {...props} isEagleSupervisor={roles.includes("eagle_supervisor")}/>
					}
				/>
			)
	}
}
EagleRoute.propTypes = {
	roles: PropTypes.array,
	component: PropTypes.node,
	fetchNumbers: PropTypes.func
}

const mapStateToProps = (state, ownProps) => ({
	roles: state.login.roles,
	...ownProps
})

const mapDispatchToProps = (dispatch, ownProps) => ({ 
	fetchNumbers: () => dispatch(inboundProgramActions.fetchNumbers()),  
})

export default connect(mapStateToProps, mapDispatchToProps)(EagleRoute)


// WEBPACK FOOTER //
// ./src/routes/EagleRoute.js